import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_more.svg'
import _imports_2 from '@/app/ui/assets/svg/trash-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-507e5bf7")

_pushScopeId("data-v-507e5bf7")
const _hoisted_1 = { class: "h-screen flex flex-col bg-white" }
const _hoisted_2 = {
  key: 0,
  class: "border-b border-gray-lp-2100 pt-3"
}
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-4 py-1.5 px-2 border-b border-gray-lp-2100" }
const _hoisted_4 = { class: "text-xl font-semibold" }
const _hoisted_5 = { class: "flex items-center gap-x-2" }
const _hoisted_6 = {
  key: 2,
  class: "h-full flex flex-col gap-y-4 pt-4"
}
const _hoisted_7 = {
  key: 0,
  class: "p-2 flex flex-row items-center rounded-md bg-yellow-lp-400 justify-between"
}
const _hoisted_8 = { class: "flex flex-row items-center gap-x-2 text-gray-lp-300" }
const _hoisted_9 = { class: "flex flex-row items-center w-full gap-x-5" }
const _hoisted_10 = { class: "underline text-red-lp-100" }
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col gap-1.5"
}
const _hoisted_12 = { class: "text-red-lp-100" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "text-sm text-gray-lp-300 font-medium" }
const _hoisted_16 = { class: "text-sm text-gray-lp-300 font-medium" }
const _hoisted_17 = { class: "text-sm text-gray-lp-300 font-medium" }
const _hoisted_18 = { class: "text-sm text-gray-lp-300 font-medium" }
const _hoisted_19 = { class: "text-sm text-gray-lp-300 font-medium" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "more_button"
}, null, -1)
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-6 h-6",
  alt: "detail"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Search = _resolveComponent("Search")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_ManageAreaTable = _resolveComponent("ManageAreaTable")!
  const _component_ModalGeoAddress = _resolveComponent("ModalGeoAddress")!
  const _component_ModalViewArea = _resolveComponent("ModalViewArea")!
  const _component_ModalConfirmDelete = _resolveComponent("ModalConfirmDelete")!
  const _component_ModalListCourier = _resolveComponent("ModalListCourier")!
  const _component_ModalEditArea = _resolveComponent("ModalEditArea")!
  const _component_TransferAreaModal = _resolveComponent("TransferAreaModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.isSidebarAndBreadcrumbV2)
        ? (_openBlock(), _createBlock("div", _hoisted_2))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.title")), 1),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_LpButton, {
            iconLeft: "maps-pin",
            iconV2: "",
            sizeIcon: "w-5",
            textColor: "red-lp-100",
            outline: "",
            title: _ctx.$t('pickupDashboard.manageArea.viewYourArea'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModalViewArea = true)),
            disabled: _ctx.disableShowArea,
            iconGroupHoverColor: 
            _ctx.disableShowArea ? 'text-gray-lp-600' : 'text-red-lp-100'
          
          }, null, 8, ["title", "disabled", "iconGroupHoverColor"])
        ])
      ]),
      (_ctx.summaryGeoAddressData.data.assigned === 0)
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 1,
            unassigned: _ctx.summaryGeoAddressData.data.unassigned,
            onOnAdjustArea: _cache[2] || (_cache[2] = () => _ctx.$router.push('/pickup-dashboard/manage-area/create')),
            onOnViewArea: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModalViewArea = true))
          }, null, 8, ["unassigned"]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            (_ctx.summaryGeoAddressData.data.unassigned > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("img", {
                      src: require('@/app/ui/assets/svg/warning-circle.svg'),
                      alt: "info-circle"
                    }, null, 8, ["src"]),
                    _createVNode("span", null, _toDisplayString(_ctx.$t("pickupDashboard.manageArea.unassignedBanner", {
                count: _ctx.summaryGeoAddressData.data.unassigned
              })), 1)
                  ]),
                  _createVNode(_component_LpButton, {
                    title: _ctx.$t('pickupDashboard.manageArea.setDedicatedCourier'),
                    fontWeight: "semibold",
                    textColor: "white",
                    onClick: _cache[4] || (_cache[4] = () => _ctx.$router.push('/pickup-dashboard/manage-area/create'))
                  }, null, 8, ["title"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickupDashboard.manageArea.search'),
                fontsize: "14"
              }, {
                default: _withId(() => [
                  _createVNode(_component_Search, {
                    placeholder: _ctx.$t('pickupDashboard.manageArea.searchPlaceholder'),
                    class: "w-100 h-9 mt-2",
                    timeout: 300,
                    minChar: 3,
                    isIconLeft: true,
                    isIconClearRight: true,
                    value: _ctx.filter.q,
                    onClear: () => _ctx.onSearch(''),
                    onEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearch($event.target.value)))
                  }, null, 8, ["placeholder", "value", "onClear"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pickupDashboard.manageArea.sort'),
                fontsize: "14"
              }, {
                default: _withId(() => [
                  _createVNode(_component_Select, {
                    onOpenSelect: _ctx.onOpenSortNameType,
                    onCloseSelect: _ctx.onCloseSelectSortNameType,
                    isOpenMenu: _ctx.isOpenSortNameType,
                    value: _ctx.sortByName,
                    onChooseSelect: _ctx.onSelectSortNameType,
                    dataSelect: _ctx.sortNameOption,
                    customClass: "w-28 h-9 mt-2"
                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            (_ctx.filter.q && !_ctx.manageAreaData.list.length)
              ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                  key: 1,
                  class: "mb-4",
                  "error-message": _ctx.$t('pickupDashboard.manageArea.searchNotFoundHint'),
                  "error-title": _ctx.$t('pickupDashboard.manageArea.searchNotFound'),
                  "error-image": "ill_spot_search"
                }, null, 8, ["error-message", "error-title"]))
              : (_openBlock(), _createBlock(_component_ManageAreaTable, {
                  key: 2,
                  column: _ctx.column,
                  tableData: _ctx.manageAreaData.list,
                  sortDirection: _ctx.filter.sort,
                  sortBy: _ctx.filter.orderBy,
                  pagination: _ctx.manageAreaData.pagination,
                  loading: _ctx.isLoading,
                  substractHeight: _ctx.substractHeight,
                  page: _ctx.manageAreaData.pagination.page,
                  "onUpdate:page": _cache[6] || (_cache[6] = ($event: any) => (_ctx.manageAreaData.pagination.page = $event)),
                  onRequest: _ctx.getList,
                  onSort: _ctx.onSort
                }, {
                  area_name: _withId((slotProp) => [
                    _createVNode("div", {
                      class: "flex flex-col gap-1.5 cursor-pointer",
                      onClick: () => _ctx.showAreaDistrict(slotProp.data)
                    }, [
                      _createVNode("div", {
                        title: `${slotProp.data.areaName}`,
                        class: "text-black-lp-100 text-sm two-line"
                      }, _toDisplayString(slotProp.data.areaName), 9, ["title"]),
                      _createVNode("span", _hoisted_10, _toDisplayString(slotProp.data.totalGeoAddress) + " " + _toDisplayString(_ctx.$t("pickupDashboard.manageArea.subDistrict")), 1)
                    ], 8, ["onClick"])
                  ]),
                  courier_id: _withId((slotProp) => [
                    (slotProp.data.couriers.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("div", {
                            class: "font-medium text-sm two-line text-gray-lp-300 cursor-pointer",
                            onClick: ($event: any) => (_ctx.openModalListCourier(slotProp.data))
                          }, [
                            _createTextVNode(_toDisplayString(slotProp.data.couriers[0].courierId) + " - " + _toDisplayString(slotProp.data.couriers[0].courierName) + " ", 1),
                            _createVNode("span", _hoisted_12, _toDisplayString(slotProp.data.couriers.length > 1
                    ? `[+${slotProp.data.couriers.length - 1} ${_ctx.$t(
                        "pickupDashboard.manageArea.moreCourier"
                      )}]`
                    : ""), 1)
                          ], 8, ["onClick"]),
                          _createVNode("button", {
                            class: "flex flex-row gap-1 text-sm text-gray-lp-600 font-medium items-center",
                            onClick: () => _ctx.whatsapp(slotProp.data.couriers[0].courierPhone)
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.formatPhoneNumber(slotProp.data.couriers[0].courierPhone)) + " ", 1),
                            _hoisted_13
                          ], 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_14, "-"))
                  ]),
                  shipment_type: _withId((slotProp) => [
                    _createVNode("p", _hoisted_15, _toDisplayString(slotProp.data.dedicatedShipment || "-"), 1)
                  ]),
                  created_at: _withId((slotProp) => [
                    _createVNode("p", _hoisted_16, _toDisplayString(slotProp.data.createdAt
                ? `${_ctx.formatDate(slotProp.data.createdAt)}`
                : "-"), 1)
                  ]),
                  created_by: _withId((slotProp) => [
                    _createVNode("p", _hoisted_17, _toDisplayString(slotProp.data.createdBy || "-"), 1)
                  ]),
                  updated_at: _withId((slotProp) => [
                    _createVNode("p", _hoisted_18, _toDisplayString(slotProp.data.updatedAt
                ? `${_ctx.formatDate(slotProp.data.updatedAt)}`
                : "-"), 1)
                  ]),
                  updated_by: _withId((slotProp) => [
                    _createVNode("p", _hoisted_19, _toDisplayString(slotProp.data.updatedBy || "-"), 1)
                  ]),
                  action: _withId(({ data, index }) => [
                    _createVNode("button", {
                      onClick: ($event: any) => (_ctx.toggleActionOP($event, index))
                    }, [
                      _hoisted_20
                    ], 8, ["onClick"]),
                    _createVNode(_component_OverlayPanel, {
                      ref: (el) => _ctx.actionOPRefs[index] = el,
                      class: "rounded-md",
                      style: {"width":"312px"}
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_21, [
                          _createVNode("div", {
                            class: "flex flex-row gap-2 items-center text-left py-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 cursor-pointer",
                            onClick: ($event: any) => (_ctx.onEditArea(data, $event, index))
                          }, [
                            _createVNode(_component_Icons, {
                              name: "pencil-edit",
                              class: "w-6 p-1 text-gray-lp-800"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.manageArea.edit")), 1)
                          ], 8, ["onClick"]),
                          _createVNode("div", {
                            class: "flex flex-row gap-2 items-center text-left py-3 text-sm text-gray-lp-300 font-medium border-b border-gray-lp-400 cursor-pointer",
                            onClick: ($event: any) => (_ctx.onTransferArea(data, $event, index))
                          }, [
                            _createVNode(_component_Icons, {
                              name: "maps-pin",
                              class: "w-6 p-1 text-gray-lp-800"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.manageArea.transferArea")), 1)
                          ], 8, ["onClick"]),
                          _createVNode("div", {
                            class: "flex flex-row gap-2 items-center text-left py-3 text-sm text-red-lp-2000 font-medium cursor-pointer",
                            onClick: ($event: any) => (_ctx.onDeleteClick(data))
                          }, [
                            _hoisted_22,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupDashboard.manageArea.delete")), 1)
                          ], 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1536)
                  ]),
                  _: 1
                }, 8, ["column", "tableData", "sortDirection", "sortBy", "pagination", "loading", "substractHeight", "page", "onRequest", "onSort"]))
          ]))
    ]),
    _createVNode(_component_ModalGeoAddress, {
      modelValue: _ctx.openModalGeoAddress,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModalGeoAddress = $event)),
      data: _ctx.selectedData
    }, null, 8, ["modelValue", "data"]),
    _createVNode(_component_ModalViewArea, {
      modelValue: _ctx.openModalViewArea,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModalViewArea = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_ModalConfirmDelete, {
      visible: _ctx.showDeleteModal,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteModal = $event)),
      data: _ctx.dataToDelete,
      loading: _ctx.isDeleting,
      onConfirm: _ctx.handleDelete
    }, null, 8, ["visible", "data", "loading", "onConfirm"]),
    (_ctx.isShowModalListCourier)
      ? (_openBlock(), _createBlock(_component_ModalListCourier, {
          key: 0,
          data: _ctx.courierData,
          onClose: _ctx.closeModalListCourier
        }, null, 8, ["data", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.detailData)
      ? (_openBlock(), _createBlock(_component_ModalEditArea, {
          key: 1,
          modelValue: _ctx.isShowModalEditArea,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isShowModalEditArea = $event)),
          data: _ctx.detailData,
          unassigned: _ctx.summaryGeoAddressData.data.unassigned,
          onSuccess: _ctx.onSuccessEdit,
          onError: _ctx.onErrorEdit
        }, null, 8, ["modelValue", "data", "unassigned", "onSuccess", "onError"]))
      : _createCommentVNode("", true),
    (_ctx.detailData)
      ? (_openBlock(), _createBlock(_component_TransferAreaModal, {
          key: 2,
          modelValue: _ctx.isOpenModalTransferArea,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isOpenModalTransferArea = $event)),
          data: _ctx.detailData,
          onSubmitSuccess: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getList(true)))
        }, null, 8, ["modelValue", "data"]))
      : _createCommentVNode("", true)
  ], 64))
})